document.querySelectorAll('.teaser-toggle').forEach(function (button) {
  button.addEventListener('click', function () {
    const teaser = button.closest('.teaser');
    const description = teaser.querySelector('.teaser-description');
    const icon = button.querySelector('.teaser-icon');

    description.classList.toggle('is-visible');
    button.classList.toggle('is-open');

    if (description.classList.contains('is-visible')) {
      button.childNodes[0].textContent = 'schließen ';
    } else {
      button.childNodes[0].textContent = 'mehr lesen ';
    }

    icon.classList.toggle('is-rotated');
  });
});
